var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoho-forward-settings" },
    [
      _c("div", { staticClass: "mode-card" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c(
              "div",
              { staticClass: "title-content" },
              [
                _c("ZohoIcon", { staticClass: "zoho-icon" }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "title-text" }, [
                    _vm._v(_vm._s(_vm.$t("message.autoTransfer"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtitle" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.autoTransferDescription")) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-switch", {
              staticClass: "md-warning ml-3",
              attrs: {
                "checked-children": "✔",
                "un-checked-children": "✖",
                checked: _vm.isZohoForwardEnabled(),
              },
              on: { change: _vm.toggleZohoForward },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isZohoForwardEnabled()
          ? _c(
              "div",
              { staticClass: "settings-content" },
              [
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "apply-to-channels-section" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "dashed", icon: "copy" },
                        on: {
                          click: function ($event) {
                            _vm.showApplyToChannelsModal = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Bu Ayarları Diğer Kanallara Uygula\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "a-collapse",
                  {
                    staticClass: "zoho-settings-accordion",
                    attrs: { bordered: false },
                    model: {
                      value: _vm.activeAccordionKeys,
                      callback: function ($$v) {
                        _vm.activeAccordionKeys = $$v
                      },
                      expression: "activeAccordionKeys",
                    },
                  },
                  [
                    _c(
                      "a-collapse-panel",
                      {
                        key: "phoneFormat",
                        attrs: { header: "Telefon Numarası Formatı" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "setting-section" },
                          [
                            _c(
                              "a-radio-group",
                              {
                                staticClass: "phone-format-radios",
                                on: { change: _vm.updateClone },
                                model: {
                                  value:
                                    _vm.cloneChannel.zohoForward.phoneFormat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cloneChannel.zohoForward,
                                      "phoneFormat",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "cloneChannel.zohoForward.phoneFormat",
                                },
                              },
                              [
                                _c(
                                  "a-radio",
                                  { attrs: { value: "E164_WITHOUT_PLUS" } },
                                  [
                                    _vm._v(
                                      "E.164 (+'sız) - Varsayılan (905xxxxxxxxx)"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-radio",
                                  { attrs: { value: "E164_WITH_PLUS" } },
                                  [_vm._v("E.164 (+'lı) (+905xxxxxxxxx)")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-collapse-panel",
                      {
                        key: "leadWizard",
                        attrs: { header: "Lead Oluşturma Sihirbazı" },
                      },
                      [
                        _c("div", { staticClass: "setting-section" }, [
                          _c("div", { staticClass: "section-title" }, [
                            _vm._v("Lead Oluşturma Sihirbazı"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-desc" }, [
                            _vm._v(
                              "\n                    Zoho'da Lead oluşturulurken hangi alanların hangi değerlerle doldurulacağını buradan\n                    ayarlayabilirsiniz. Değer kısmına statik metin yazabilir veya\n                    "
                            ),
                            _c("code", { pre: true }, [
                              _vm._v("{{ contact.name }}"),
                            ]),
                            _vm._v(
                              " gibi dinamik değişkenler kullanabilirsiniz.\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "variable-helpers" }, [
                            _c("span", { staticClass: "helper-label" }, [
                              _vm._v("Kullanılabilir Değişkenler:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "tags" },
                              _vm._l(_vm.availableVariables, function (v) {
                                return _c(
                                  "a-tag",
                                  {
                                    key: v.key,
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyVariable(v.key)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(v.label) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mapped-fields" },
                            _vm._l(_vm.leadFields, function (value, key) {
                              return _c(
                                "div",
                                { key: key, staticClass: "field-item" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "field-header" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldLabel(key)) + " "
                                          ),
                                          _c("small", [
                                            _vm._v("(" + _vm._s(key) + ")"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("a-button", {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          type: "link",
                                          icon: "delete",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeField(key)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isPicklistField(key)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "picklist-field-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "field-mode-toggle",
                                            },
                                            [
                                              _c(
                                                "a-radio-group",
                                                {
                                                  attrs: {
                                                    value: _vm.fieldModes[key],
                                                    size: "small",
                                                    "button-style": "solid",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onFieldModeChange(
                                                        key
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-radio-button",
                                                    {
                                                      attrs: {
                                                        value: "static",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setFieldMode(
                                                            key,
                                                            "static"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Statik")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-radio-button",
                                                    {
                                                      attrs: {
                                                        value: "dynamic",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setFieldMode(
                                                            key,
                                                            "dynamic"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Dinamik")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.fieldModes[key] === "static"
                                            ? _c(
                                                "div",
                                                { staticClass: "static-mode" },
                                                [
                                                  _c("CustomPicker", {
                                                    attrs: {
                                                      items:
                                                        _vm.getPicklistValues(
                                                          key
                                                        ),
                                                      idKey: "actual_value",
                                                      labelKey: "display_value",
                                                      title: "Değer Seçin",
                                                    },
                                                    on: {
                                                      input: _vm.updateClone,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.cloneChannel
                                                          .zohoForward
                                                          .leadFields[key],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.cloneChannel
                                                            .zohoForward
                                                            .leadFields,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cloneChannel.zohoForward.leadFields[key]",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "dynamic-mode" },
                                                [
                                                  _c(
                                                    "a-popover",
                                                    {
                                                      attrs: {
                                                        trigger: "manual",
                                                        placement: "bottomLeft",
                                                        overlayClassName:
                                                          "variable-suggestions-popover",
                                                        getPopupContainer:
                                                          function (trigger) {
                                                            return trigger.parentNode
                                                          },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "content",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    ref:
                                                                      "popover_dynamic_" +
                                                                      key,
                                                                    refInFor: true,
                                                                    staticClass:
                                                                      "variable-suggestions",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "suggestion-search",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a-input-search",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Değişken ara...",
                                                                                size: "small",
                                                                              },
                                                                            on: {
                                                                              keydown:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "esc",
                                                                                      27,
                                                                                      $event.key,
                                                                                      [
                                                                                        "Esc",
                                                                                        "Escape",
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.closePopover(
                                                                                    key
                                                                                  )
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm.variableSearchQuery,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.variableSearchQuery =
                                                                                      $$v
                                                                                  },
                                                                                expression:
                                                                                  "variableSearchQuery",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "suggestion-list",
                                                                      },
                                                                      [
                                                                        _vm._l(
                                                                          _vm.getFilteredVariables(),
                                                                          function (
                                                                            v
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key: v.key,
                                                                                staticClass:
                                                                                  "suggestion-item",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.insertVariable(
                                                                                        key,
                                                                                        v.key
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "var-label",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        v.label
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "var-key",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.formatVariable(
                                                                                          v.key
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm.getFilteredVariables()
                                                                          .length ===
                                                                        0
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "no-results",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                    Sonuç bulunamadı\n                                                "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm
                                                            .fieldPopoverVisible[
                                                            key
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.fieldPopoverVisible,
                                                            key,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fieldPopoverVisible[key]",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("a-input", {
                                                        ref:
                                                          "input_dynamic_" +
                                                          key,
                                                        refInFor: true,
                                                        attrs: {
                                                          placeholder:
                                                            "Değer giriniz... ({ karakteri ile değişken ekleyebilirsiniz)",
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.updateClone,
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleInputKeyup(
                                                              $event,
                                                              key
                                                            )
                                                          },
                                                          keydown: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "esc",
                                                                27,
                                                                $event.key,
                                                                [
                                                                  "Esc",
                                                                  "Escape",
                                                                ]
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            return _vm.closePopover(
                                                              key
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleInputBlur(
                                                              key
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.cloneChannel
                                                              .zohoForward
                                                              .leadFields[key],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.cloneChannel
                                                                .zohoForward
                                                                .leadFields,
                                                              key,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "cloneChannel.zohoForward.leadFields[key]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      )
                                    : _c(
                                        "a-popover",
                                        {
                                          attrs: {
                                            trigger: "manual",
                                            placement: "bottomLeft",
                                            overlayClassName:
                                              "variable-suggestions-popover",
                                            getPopupContainer: function (
                                              trigger
                                            ) {
                                              return trigger.parentNode
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        ref: "popover_" + key,
                                                        refInFor: true,
                                                        staticClass:
                                                          "variable-suggestions",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "suggestion-search",
                                                          },
                                                          [
                                                            _c(
                                                              "a-input-search",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "Değişken ara...",
                                                                  size: "small",
                                                                },
                                                                on: {
                                                                  keydown:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        !$event.type.indexOf(
                                                                          "key"
                                                                        ) &&
                                                                        _vm._k(
                                                                          $event.keyCode,
                                                                          "esc",
                                                                          27,
                                                                          $event.key,
                                                                          [
                                                                            "Esc",
                                                                            "Escape",
                                                                          ]
                                                                        )
                                                                      ) {
                                                                        return null
                                                                      }
                                                                      return _vm.closePopover(
                                                                        key
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.variableSearchQuery,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.variableSearchQuery =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "variableSearchQuery",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "suggestion-list",
                                                          },
                                                          [
                                                            _vm._l(
                                                              _vm.getFilteredVariables(),
                                                              function (v) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: v.key,
                                                                    staticClass:
                                                                      "suggestion-item",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertVariable(
                                                                            key,
                                                                            v.key
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "var-label",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            v.label
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "var-key",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.formatVariable(
                                                                              v.key
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.getFilteredVariables()
                                                              .length === 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "no-results",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                            Sonuç bulunamadı\n                                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.fieldPopoverVisible[key],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.fieldPopoverVisible,
                                                key,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "fieldPopoverVisible[key]",
                                          },
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("a-input", {
                                            ref: "input_" + key,
                                            refInFor: true,
                                            attrs: {
                                              placeholder:
                                                "Değer giriniz... ({ karakteri ile değişken ekleyebilirsiniz)",
                                            },
                                            on: {
                                              change: _vm.updateClone,
                                              keyup: function ($event) {
                                                return _vm.handleInputKeyup(
                                                  $event,
                                                  key
                                                )
                                              },
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.closePopover(key)
                                              },
                                              blur: function ($event) {
                                                return _vm.handleInputBlur(key)
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.cloneChannel.zohoForward
                                                  .leadFields[key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.cloneChannel.zohoForward
                                                    .leadFields,
                                                  key,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "cloneChannel.zohoForward.leadFields[key]",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "add-field-wrapper" },
                            [
                              _c("CustomPicker", {
                                attrs: {
                                  items: _vm.availableZohoFields,
                                  idKey: "api_name",
                                  labelKey: "field_label",
                                  title: "Alan Ekle",
                                  icon: "add",
                                },
                                model: {
                                  value: _vm.selectedFieldToAdd,
                                  callback: function ($$v) {
                                    _vm.selectedFieldToAdd = $$v
                                  },
                                  expression: "selectedFieldToAdd",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  attrs: {
                                    primary: "",
                                    disabled: !_vm.selectedFieldToAdd,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addField(
                                        _vm.selectedFieldToAdd
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Ekle")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Ayarları Diğer Kanallara Uygula",
            okText: "Uygula",
            cancelText: "İptal",
            width: "600px",
          },
          on: { ok: _vm.applySettingsToChannels },
          model: {
            value: _vm.showApplyToChannelsModal,
            callback: function ($$v) {
              _vm.showApplyToChannelsModal = $$v
            },
            expression: "showApplyToChannelsModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "apply-channels-content" },
            [
              _c("a-alert", {
                staticStyle: { "margin-bottom": "15px" },
                attrs: {
                  message: "Dikkat",
                  description:
                    "Seçtiğiniz kanallardaki mevcut Zoho ayarları değiştirilecektir. Bu işlem geri alınamaz.",
                  type: "warning",
                  "show-icon": "",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "channel-selection-info" }, [
                _c("strong", [_vm._v("Uygulanacak Ayarlar:")]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "Telefon Numarası Formatı: " +
                        _vm._s(_vm.getPhoneFormatLabel())
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Lead Alanları: " +
                        _vm._s(
                          Object.keys(
                            _vm.$_.get(
                              _vm.cloneChannel,
                              "zohoForward.leadFields",
                              {}
                            ) || {}
                          ).length
                        ) +
                        " alan"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("a-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "channels-list" }, [
                _c(
                  "div",
                  { staticClass: "list-header" },
                  [
                    _c(
                      "a-checkbox",
                      {
                        attrs: {
                          indeterminate:
                            _vm.selectedChannelIds.length > 0 &&
                            _vm.selectedChannelIds.length <
                              _vm.availableChannelsForCopy.length,
                          checked:
                            _vm.selectedChannelIds.length ===
                              _vm.availableChannelsForCopy.length &&
                            _vm.availableChannelsForCopy.length > 0,
                        },
                        on: { change: _vm.onSelectAllChannels },
                      },
                      [
                        _vm._v(
                          "\n                        Tümünü Seç\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "channel-items" },
                  [
                    _c(
                      "a-checkbox-group",
                      {
                        model: {
                          value: _vm.selectedChannelIds,
                          callback: function ($$v) {
                            _vm.selectedChannelIds = $$v
                          },
                          expression: "selectedChannelIds",
                        },
                      },
                      _vm._l(_vm.availableChannelsForCopy, function (ch) {
                        return _c(
                          "div",
                          { key: ch._id, staticClass: "channel-item" },
                          [
                            _c(
                              "a-checkbox",
                              { attrs: { value: ch._id } },
                              [
                                _c("span", { staticClass: "channel-name" }, [
                                  _vm._v(_vm._s(ch.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color: _vm.getChannelTypeColor(ch.type),
                                      size: "small",
                                    },
                                  },
                                  [_vm._v(_vm._s(ch.type))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.availableChannelsForCopy.length === 0
                      ? _c("div", { staticClass: "no-channels" }, [
                          _vm._v(
                            "\n                        Ayarları kopyalayabileceğiniz başka kanal bulunmamaktadır.\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }